import React from "react";
import { Card, CardBody, Container, Row, Col, Button } from "reactstrap";
import { getStats } from "../../components/helpers/StatsHelpers";
import { RiAddCircleLine } from "react-icons/ri";
import { SeoHelper } from "../../components/helpers/SeoHelper";
import InstructionsWizard from "./InstructionsWizard";

class AddingSongsFromMultipleSourcesHelp extends React.Component {
  state = { songBookCount: null };

  constructor(props) {
    super(props);
    getStats.call(this);
  }

  stepsData = [
    {
      title: "Adding songs from multiple sources",
      description:
        "At the end of this guide you will be able to:<br/><br/>" +
        "<img src=\"/help-images/blue-arrow.png\" style=\"width: 40px; height: auto;\">&nbsp;" +
        "build a richer song-flow by combining songs found through Scripture, themes, and lectionary readings",
    },
    {
      title: "Start with one source",
      description:
        "Begin by building your song-flow using whichever source suits your service — Scripture, a theme, or a search. " +
        "Select the songs you want and you will arrive at the song results page. " +
        "You do not need to click <b>CURATE SONG-FLOW</b> yet — stay on the song results page to add more songs.",
    },
    {
      title: "Add songs from Scripture",
      description:
        "At the bottom of the song results page, find the <b>Add additional songs</b> section. " +
        "Click <b>ADD FROM SCRIPTURE</b> to go back to the Scripture selection page and choose another passage. " +
        "The songs you have already selected will be retained when you return.",
    },
    {
      title: "Add songs from a Theme",
      description:
        "In the same <b>Add additional songs</b> section, click <b>ADD FROM THEME</b> to go to the theme selection page. " +
        "Select a theme and continue to the song results. Your previously selected songs are still included.",
    },
    {
      title: "Add songs from a Lectionary",
      description:
        "Click <b>ADD FROM LECTIONARY</b> to add songs based on a lectionary reading. " +
        "This requires a paid account. Select your denomination's lectionary, choose a reading, and the resulting songs will be added to your existing selection." +
        "<br/><br/>If you are not signed in or do not have a paid account, this option will prompt you to sign in or register.",
    },
    {
      title: "Curate your combined song-flow",
      description:
        "Once you have gathered songs from all the sources you need, click <b>CURATE SONG-FLOW</b> at the bottom of the song results page. " +
        "All your selected songs from every source will appear together in your song-flow, ready to reorder and save.",
    },
    {
      title: "What's next",
      description:
        "You have built a song-flow from multiple sources." +
        "<br/><br/><img src=\"/help-images/star.png\" style=\"width: 40px; height: auto;\"> <a href='/help/reordering-songs-in-your-song-flow'>Reorder songs in your song-flow</a>" +
        "<br/><br/><img src=\"/help-images/star.png\" style=\"width: 40px; height: auto;\"> <a href='/help/saving-and-managing-your-song-flows'>Save and manage your song-flows</a>" +
        "<br/><br/><img src=\"/help-images/star.png\" style=\"width: 40px; height: auto;\"> <a href='/help/sharing-a-song-flow'>Share your song-flow with your team</a>",
      image: "/help-images/well-done.png",
      enlargeable: false,
    },
  ];

  render() {
    return (
      <>
        <SeoHelper
          uri="/help/adding-songs-from-multiple-sources"
          title="Adding songs from multiple sources | Help | The Worship Bible"
          description="How to build a richer song-flow by adding songs from Scripture, themes, and lectionary readings together."
        />
        <div className="position-relative">
          <section className="section section-lg section-shaped pb-250">
            <div className="shape shape-style-1 shape-default">
              <span/><span/><span/><span/><span/><span/><span/><span/><span/>
            </div>
            <Container className="py-lg-md d-flex">
              <div className="col px-0">
                <Row>
                  <Col lg="8">
                    <h1 className="display-3 text-white">
                      Building your song-flows{" "}<span>help</span>
                    </h1>
                  </Col>
                </Row>
              </div>
            </Container>
            <div className="separator separator-bottom separator-skew">
              <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" version="1.1" viewBox="0 0 2560 100" x="0" y="0">
                <polygon className="fill-white" points="2560 0 2560 100 0 100"/>
              </svg>
            </div>
          </section>
        </div>
        <section className="section section-lg pt-lg-0 mt--200">
          <Container>
            <Row className="justify-content-center">
              <Col lg="12">
                <Row className="row-grid">
                  <Col lg="12">
                    <Card className="card-lift--hover shadow border-0">
                      <CardBody className="py-5">
                        <Row className="mt-3">
                          <Col>
                            <div className="d-flex align-items-center mb-3">
                              <RiAddCircleLine color="#5e72e4" size="24" className="mr-2"/>
                              <h2 style={{fontSize: "1rem"}} className="text-primary mb-0">Adding songs from multiple sources</h2>
                            </div>
                          </Col>
                          <Col md="3" xs="12">
                            <Button block type="button" className="mb-2" color="white" href="/help">
                              <span className="btn-inner--text">Back to help</span>
                            </Button>
                          </Col>
                        </Row>
                        <InstructionsWizard stepsData={this.stepsData}/>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>
      </>
    );
  }
}

export default AddingSongsFromMultipleSourcesHelp;
